var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userRole === 'admin')?_c('div',{staticClass:"tenant-select"},[_c('v-select',{attrs:{"label":"company_name","options":_vm.tenants,"clearable":false},on:{"input":_vm.switchTenant},model:{value:(_vm.currentTenant),callback:function ($$v) {_vm.currentTenant=$$v},expression:"currentTenant"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f9dfbc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/TenantSelect.vue
// module id = 380
// module chunks = 0